<template>
  <div class="main">
    <div class="textInfo">
      <img :src="imgList[0]" alt="">
      <span>如需核销或退订请联系您的归属导购线下处理，谢谢！</span>
    </div>
    <Tabs v-model="tabsType"  @change="tabsChange">
      <tab title="标签 1" v-for="(item,index) in tabs" :key="index" :name="item.type" :title="item.name"></tab>
    </Tabs>
    <div v-show="switchs" class="switch-block">
      <div class="switch">
        <div v-for="(item,index) in switchs" :key="index" :class="{'active': switchType === item.type }" @click="changeSwitch(item.type)">
          {{item.name}}
        </div>
      </div>
    </div>
    <div class="orderNumer">共{{pagingInfo.total}}单</div>
    <pull-refresh @refresh="refreshData" v-model="refreshing">
     <div class="card-list">
       <card-list
         @onClick="goToOrderDetail"
         :cardList="list"
         :cardType="type"
         :finished="finished"
         :error="error"
         :loading="isLoading"
         :refreshing="refreshing"
         :infoText="noText[type]"
         @getData="getData"
         @writeOff="onWriteOff"/>
     </div>
    </pull-refresh>
    <!--核销二维码-->
    <VerificationQrcode ref="verificationQrcode"></VerificationQrcode>
    <ComplaintEntry></ComplaintEntry>
    <!--中奖弹窗提示-->
    <LotteryPopup :show.sync="showPopup" :prize-data="prizeData" :showButton="false" ref="lotteryPopup" @giveUp="giveUp"></LotteryPopup>
    <GroupPurchaseWelfare :show.sync="showGroupPurchasePopup" :img="welfareImage">
      <template slot="content">
        <GroupBuyProgress class="group-buy-progress" :groupInfo="groupInfo"
                          :type="groupOrderType"></GroupBuyProgress>
      </template>
    </GroupPurchaseWelfare>
  </div>
</template>

<script>

import { PullRefresh, Popup, Tab, Tabs } from 'vant';
import CardList from '../../components/CardList';
import VerificationQrcode from '../components/myOrder/VerificationQrcode';
import GroupPurchaseWelfare from '../components/myOrder/GroupPurchaseWelfare';
import filters from '../../../utils/filters';
import { mapMutations } from 'vuex';
import ComplaintEntry from '../../components/ComplaintEntry';
import LotteryPopup from '../components/lottery/LotteryPopup';
import GroupBuyProgress from '../components/GroupBuyProgress';
export default {
  components: {
    PullRefresh,
    CardList,
    Popup,
    Tab,
    Tabs,
    ComplaintEntry,
    VerificationQrcode,
    GroupPurchaseWelfare,
    LotteryPopup,
    GroupBuyProgress
  },
  data() {
    return {
      imgAddr: systemConfig.imageServer,
      modalCss: {
        "min-width": '200px',
        "min-height": '200px'
      },
      opened: false,
      isLoading: false,
      refreshing: false,
      list: [],
      tabs:[
        {
          name:'秒杀',
          type: 1
        },
        {
          name:'购卡',
          type: 4
        },
        {
          name:'直播下订',
          type: 2
        },
        {
          name:'优惠券',
          type: 3
        },
        {
          name:'集赞礼品',
          type: 6
        },
        {
          name:'抽奖奖品',
          type: 7
        }
      ],
      finished: false,
      error: false,
      pagingInfo: {
        pageNo: 0,
        pageSize: 10,
        total:0
      },
      type:0,
      tabsType: '',
      switchType: '',
      noText: [
        '您还没有秒杀助力中的产品哦，快去参与活动吧~~',
        '您还没有秒杀产品哦，快去参与活动吧~~',
        '您还没有下订呢~~',
        '您还没有领取优惠券呢，快去首页领取吧~~',
        '您还没有购卡呢~~',
        '您还没有集赞中的礼品呢~~',
        '您还没有已完成集赞的礼品呢~~',
        '您还没有抽奖奖品呢~~',
      ],
      imgList:['info.png'],
      showPopup: false,
      prizeData: null,
      showGroupPurchasePopup: false,
      welfareImage: '',
      groupInfo: null,
      groupOrderType: 0,
    };
  },
  computed: {
    userId() {
      return  this.$fission.user.id;
    },
    switchs() {
      if(this.type == 1 || this.type == 0){
        return [
          {
            name: '秒杀商品',
            type: 1
          },
          {
            name: '秒杀助力中',
            type: 0
          }
        ];
      }
      if(this.type == 5 || this.type == 6){
        return [
          {
            name: '集赞完成',
            type: 6
          },
          {
            name: '集赞中',
            type: 5
          }
        ];
      }
      return null;
    }
  },
  created() {
    this.$fission.setImgAddress('user/mine/', this.imgList);
  },
  activated() {
    // 0 秒杀助力 1 秒杀 2 下订 3 优惠券 4 购卡
    this.tabsType = this.switchType = this.type = parseInt(this.$route.query.type);
    this.refreshData();
  },
  methods: {
    ...mapMutations('lovehome', [
      'UPDATA_SHIPPING_ADDRESS',
    ]),
    // 时间格式化
    dateFmt(v) {
      return filters.formatDate(v,'YYYY-MM-DD HH:mm:ss')
    },
    goToOrderDetail(item) {
      if(this.type === 0 || this.type === 5 || this.type === 3 || (this.type === 7 && item.type !== 1)) {
        return;
      }
      this.$fission.setOrderDetail(item);
      this.$router.push({name: 'CustomerPersonalMyOrderDetail', query: {type: this.type}});
    },
    async getData() {
      switch (this.type) {
        case 0:
          this.getSecKillOrderPage();
          break;
        case 1:
          this.getCustomerOrderPage('2');
          break;
        case 2:
          this.getCustomerOrderPage('3');
          break;
        case 3:
          this.getCouponList();
          break;
        case 4:
          this.getCustomerOrderPage('50');
          break;
        case 5:
          this.getCollectLikeIngOrderPage();
          break;
        case 6:
          this.getCustomerOrderPage('70');
          break;
        case 7:
          await this.refreshLotteryLogByUserAccountId();
          this.getPrizeList();
          break;
        default: break;
      }
    },
    giveUp() {
      this.refreshData();
    },
    tabsChange() {
      this.type = this.switchType = this.tabsType;
      this.changeRoute(this.type);
      this.refreshData();
    },
    changeRoute(type) {
      let href = window.location.href;
      href = href.split('?');
      href = href[0];
      let query = this.$route.query;
      query = Object.assign(query,{type});
      let params = '';
      Object.keys(query).forEach((key,index)=>{
        if(index!==0) {
          params += '&';
        }
        params += `${key}=${query[key]}`
      });
      window.history.replaceState({},"我的订单",`${href}?${params}`);
    },
    changeSwitch(type) {
      this.type = this.switchType = type;
      this.changeRoute(type);
      this.refreshData();
    },
    // 下拉刷新判断
    refreshData() {
      this.list = [];
      // 开启下拉刷新Loading
      this.refreshing = true;
      this.finished = false;
      this.pagingInfo.pageNo = 0;
      this.pagingInfo.total = 0;
      this.getData();
    },
    getLotteryStatusName(item) {
      let btn = ['兑换说明'];
      let status = '';
      // 已失效
      if(item.receiveStatus == 2) {
        // 用户放弃领取奖品
        if(item.remark === '用户放弃领取奖品') {
          btn = [];
        }
        status = '已失效';
      }else if(item.receiveStatus == 1) {
        // 不需要发货
        if(!item.needMail) {
          // 之前原型是线下核销，不做处理
          status = '已领取';
        } else{
          // 需要发货，判断物流状态
          if(item.expressStatus == 1) {
            status = '已发货';
          }else if(item.expressStatus == 0){
            status = '待发货';
          }
        }
      }else if(item.receiveStatus == 0) {
        status = '待领取';
        //判断是否有任务
        if(item.receiveThresholdControl || item.prizeAssistantControl) {
          //判断任务是否完成
          const missionStatus = this.$request.lottery.getMissionStatus(item);
          //已完成 而且 需要发货
          if(missionStatus.status === 'done' && item.needMail) {
            btn = ['兑换说明', '填写收货信息'];
          }
        }else {
          // 没有任务
          // 判断是否需要发货
          if(item.needMail){
            btn = ['兑换说明', '填写收货信息'];
          }
        }
      }
      return {status,btn}
    },
    // 二维码生成核销
    async onWriteOff(item, type, btn) {
      if(this.type === 0  && item.stock){
        this.toProductInfo(item);
        return;
      }
      let params = {};
      if (type === 5) { // 集赞中
        // 点击领取奖品
        if(item.collectLikeStatus && item.collectLikeStatus === 2){
          this.createCollectLikeOrder(item.collectLikeItemId);
        }
        return;
      }else if (type === 6) { // 我的集赞
        if (item.delivery === 1) {
          this.UPDATA_SHIPPING_ADDRESS('');
          this.$router.push({
            name: 'SureOrder',
            query: {
              id: item.collectLikeProductId,
              type: 'collectAssist',
            }
          });
          return;
        }
        this.$refs.verificationQrcode.open(type, item);
      } else if (type === 7) { // 抽奖奖品
        if(btn === '兑换说明') {
          this.prizeData = item;
          this.showPopup = true;
          return;
        }else if(btn === '填写收货信息') {
          this.$router.push({
            name: 'SureOrder',
            query: {
              id: item.id,
              prizeImgUrl: item.imgUrl,
              prizeTitle: item.title,
              type: 'lottery'
            }
          });
          return;
        }
      }
      if ('订单核销' === btn) {
        this.$refs.verificationQrcode.open(type, item);
        return;
      }

      // 去拼团
      if ('去邀请' === btn) {
        this.toGroupBuyDetail(item);
      }

      // 赠送权益
      if ('赠送权益' === btn) {
        this.welfareImage = '';
        // TODO: 判断拼团模式
        if (item.groupType === 1) {
          this.getGroupPurchaseCommodity(item);
          this.groupOrderType = item.orderType;
        } else {
          this.welfareImage = `${this.imgAddr}${item.welfareImage}`;
        }
        this.showGroupPurchasePopup = true;
      }
      if ('取消订单' === btn) {
        const res = await this.$request.money.cancelOrder({
          productOrderId: item.orderId
        });
        if (res.status) {
          item.orderItemStatus = '-1';
          item.btnList = [];
        }
      }
      if ('去支付' === btn) {
        const buyTypeMap = {
          1: '2', // 秒杀
          4: 50, // 购卡
          2: '3', // 直播下定
        }
        let productInfo = {
          productName: item.productName,
          money: item.totalMoney,
          buyType: buyTypeMap[this.type],
          payMsg: item.productName,
          payStatus: 0
        };
        if (this.type !== 4) {
          productInfo.goodsShopId = item.goodsShopId;
        } else {
          productInfo.id = item.activityCardId;
        }
        this.$fission.setProductInfo(productInfo);
        this.$router.push({ name: 'CustomerPay' });
      }
    },
    // 我的秒杀 下订
    async getCustomerOrderPage(type) {
      this.pagingInfo.pageNo++;
      this.isLoading = true;
      await this.$request.buyDetail.getCustomerOrderPage({
        userId: this.userId,
        orderType: type,
        pageNo: this.pagingInfo.pageNo,
        pageSize: this.pagingInfo.pageSize,
      }).then(res => {
        const dataArr = res.data;
        this.pagingInfo.total = dataArr.total;
        this.isLoading = false;
        this.refreshing = false;
        if (dataArr.records && dataArr.records.length > 0) {
          const moneyDescribeMap = {
            '2': '秒杀价：',
            '3': '下订金额：',
            '50': '',
          };
          dataArr.records.forEach((item) => {
            item.actTitle = item.activityName;
            item.title = item.productName;
            item.img = item.firstImg;
            item.belongUserName = item.belongName || '暂无';
            item.belongUserMobile = item.belongMobile || '暂无';
            item.orgName = `商场：${item.belongOrgName || '暂无'}`;
            item.btnList = [];
            if (item.orderItemStatus === '3' && !item.delivery) {
              item.btnList = ['订单核销'];
            }
            if (item.orderItemStatus === '5' && !item.delivery) {
              item.writeOffName = `核销人：${item.agentName || '暂无'}`;
            }
            if(type === '70' && item.delivery && item.orderItemStatus !== '5' && !item.consigneeMobile) {
              item.btnList = ['请填写收货地址'];
            }
            item.money = item.totalMoney ? `${moneyDescribeMap[type]}￥${item.totalMoney}` : '';

            // 商品配置了拼团，但未参加拼团或未完成拼团，并且商品为当前活动的商品才显示 “去邀请” 按钮
            if (item.groupPurchaseControl && !item.welfareImage && item.activityId === this.$route.query.aid) {
              item.btnList.unshift('去邀请');
            }
            // 已完成拼团
            if (item.welfareImage) {
              item.btnList.unshift('赠送权益');
            }

            if (item.orderItemStatus === '1') {
              item.btnList = ['取消订单', '去支付'];
            }
          });
          this.list = this.list.concat(dataArr.records);
        }
        this.finished = dataArr.pages <= this.pagingInfo.pageNo;
      }).catch((err) => {
        this.isLoading = false;
        this.refreshing = false;
        this.error = true;
        this.pagingInfo.pageNo--;
      });
    },
    // 刷新用户中奖纪录状态
    async refreshLotteryLogByUserAccountId() {
      await this.$request.lottery.refreshLotteryLogByUserAccountId();
    },
    // 我的奖品
    getPrizeList() {
      this.isLoading = true;
      this.pagingInfo.pageNo++;
      this.$request.lottery.getPrizeList(this.pagingInfo).then(res => {
        const dataNew = res.data;
        this.isLoading = false;
        this.refreshing = false;
        this.pagingInfo.total = dataNew.total;
        if (dataNew.records && dataNew.records.length) {
          dataNew.records.forEach((item) => {
            const {status,btn} = this.getLotteryStatusName(item);
            item.logId = item.id,
            item.actTitle = item.activityName;
            item.img = item.imgUrl;
            item.orderNo = item.id;
            item.totalMoney = '0.00';
            item.logisticsNo = item.expressNumber; // 物流单号
            item.logisticsCompany = item.expressCompany || '-'; // 物流公司
            item.statusName = status;
            item.belongUserName = item.belongName || '暂无';
            item.belongUserMobile = item.belongMobile || '暂无';
            item.orgName = `商场：${item.belongOrgName || '暂无'}`;
            item.btnList = btn;
          });
          this.list = this.list.concat(dataNew.records);
        }
        this.finished = dataNew.pages <= this.pagingInfo.pageNo;
      }).catch(() => {
        this.isLoading = false;
        this.refreshing = false;
        this.error = true;
        this.pagingInfo.pageNo--;
      })
    },
    // 我的优惠券
    async getCouponList() {
      this.isLoading = true;
      this.pagingInfo.pageNo++;
      await this.$request.buyDetail.getCustomerCouponList({
        userId: this.userId,
        pageNo: this.pagingInfo.pageNo,
        pageSize: this.pagingInfo.pageSize,
      }).then(res => {
        const dataNew = res.data;
        this.isLoading = false;
        this.refreshing = false;
        this.pagingInfo.total = dataNew.total;
        if (dataNew.records && dataNew.records.length) {
          dataNew.records.forEach((item) => {
            item.img = item.couponImges || item.logo;
            item.actTitle = item.activityName;
            item.usageMode = `使用方式：${item.useDescribe}`;
            item.showDateTime = `截止使用日期：${this.dateFmt(item.endDt)}`;
            item.belongUserName = item.belongUserAccountName || '暂无';
            item.belongUserMobile = item.belongUserAccountMobile || '暂无';
            item.belongUserOrgName = `导购商场名称：${item.belongUserAccountOrgName}`;
            if (item.status === 2) {
              item.btnList = ['订单核销'];
            }
            if (item.status === 3) {
              item.orgName = `商场：${item.orgName || '暂无'}`;
              item.writeOffName = `核销人：${item.verificationName || '暂无'}`;
            }
            // 干掉兑奖联系电话
            // item.mobile = `兑奖联系电话：${item.verificationMobile || '暂无'}`;
          });
          this.list = this.list.concat(dataNew.records);
        }
        this.finished = dataNew.pages <= this.pagingInfo.pageNo;
      }).catch(() => {
        this.isLoading = false;
        this.refreshing = false;
        this.error = true;
        this.pagingInfo.pageNo--;
      });
    },
    // 创建集赞订单
    createCollectLikeOrder(collectLikeItemId) {
      this.$request.order.createCollectLikeOrder({collectLikeItemId}).then(res=>{
        this.$tools.successToast('领取成功！');
        this.refreshData();
      }).catch(error => this.$tools.errToast(error))
    },
    // 助力中。。。
    async getSecKillOrderPage() {
      this.isLoading = true;
      this.pagingInfo.pageNo++;
      await this.$request.buyDetail.getSecKillOrderPage({
        activityId: this.$fission.activity.id,
        userAccountId: this.$fission.user.userAccountId,
        pageNo: this.pagingInfo.pageNo,
        pageSize: this.pagingInfo.pageSize,
      }).then(res => {
        const dataNew = res.data;
        this.isLoading = false;
        this.refreshing = false;
        this.pagingInfo.total = dataNew.total;
        if (dataNew.records && dataNew.records.length) {
          dataNew.records.forEach((item) => {
            item.actTitle = item.activityName;
            item.title = item.productName;
            item.img = item.firstImg;
            item.belongUserName = item.agentName || '暂无';
            item.belongUserMobile = item.mobile || '暂无';
            item.orgName = `商场：${item.orgName || '暂无'}`;
            item.statusName = `助力进度：${item.hasAssistantNumber}/${item.assistantNumber}`;
            if (item.assistantNumber === item.hasAssistantNumber) {
              if(item.stock) {
                item.btnList = ['去支付'];
              }else{
                item.btnList = ['已被秒完'];
              }
            }
          });
          this.list = this.list.concat(dataNew.records);
        }
        this.finished = dataNew.pages <= this.pagingInfo.pageNo;
      }).catch(() => {
        this.isLoading = false;
        this.refreshing = false;
        this.error = true;
        this.pagingInfo.pageNo--;
      })
    },
    // 集赞中。。。
    async getCollectLikeIngOrderPage() {
      this.isLoading = true;
      this.pagingInfo.pageNo++;
      await this.$request.buyDetail.getCollectLikeIngOrderPage({
        activityId: this.$fission.activity.id,
        userAccountId: this.$fission.user.userAccountId,
        pageNo: this.pagingInfo.pageNo,
        pageSize: this.pagingInfo.pageSize,
      }).then(res => {
        const dataNew = res.data;
        this.isLoading = false;
        this.refreshing = false;
        this.pagingInfo.total = dataNew.total;
        if (dataNew.records && dataNew.records.length) {
          dataNew.records.forEach((item) => {
            item.actTitle = item.activityName;
            item.title = item.productName;
            item.img = item.firstImg;
            item.statusName = `集赞进度：${item.collected}/${item.likeNumber}`;
            item.belongUserName = item.belongName || '暂无';
            item.belongUserMobile = item.belongMobile || '暂无';
            item.orgName = `商场：${item.belongOrgName || '暂无'}`;
            item.btnList = item.collectLikeStatus === 2 ? ['领取奖品'] : [];
          });
          this.list = this.list.concat(dataNew.records);
        }
        this.finished = dataNew.pages <= this.pagingInfo.pageNo;
      }).catch(() => {
        this.isLoading = false;
        this.refreshing = false;
        this.error = true;
        this.pagingInfo.pageNo--;
      })
    },
    // 去秒杀产品详情
    toProductInfo(data) {
      this.$router.push({
        name: 'CustomerProductInfo',
        query: {
          id: data.goodsShopId,
          starterId: this.$fission.user.userAccountId
        },
      });
    },
    // 跳转拼团详情页
    toGroupBuyDetail(item) {
      this.$router.push({
        name: 'GroupPurchase',
        query: {
          id: item.activityCardId,
          type: item.orderType
        }
      });
    },
    // 获取阶梯式拼团信息
    async getGroupPurchaseCommodity(item) {
     await this.$request.order.getGroupPurchaseCommodity({
        activityId: item.activityId,
        userAccountId: this.$fission.user.userAccountId,
        commodityId: item.activityCardId,
        groupPurchaseItemId: '',
        commodityType: item.orderType
      }).then(res => {
        if(res.data) {
          this.groupInfo = res.data;
        }
      }).catch(err => {
        this.$tools.errToast(err);
      });
    },
  }
};
</script>

<style lang="less" scoped>
  .main{
    background-color: #f7f7f7;
    min-height: 100vh;
  }
  .textInfo{
    padding:12px 10px;
    background:#FFF4F2;
    color:#E02600;
    font-size:12px;
    display:flex;
    align-items:center;
    img{
      width:17px;
      height:18px;
      flex:0 0 auto;
      margin-right:3px;
    }
  }
  .switch-block{
    width: 100%;
    padding-top: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    .switch{
      display: flex;
      background-color: #E3E3E3;
      border-radius: 6px;
      color: #999999;
      font-size: 14px;
      padding: 2px;
      >div{
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 130px;
        padding: 8px 0;
        border-radius: 6px;
      }
      >div.active{
        background: #FFFFFF;
        color: #333333;
        font-weight: 500;
        font-size: 14px;
      }
    }
  }
  .orderNumer{
    padding: 8px 12px;
    font-size: 12px;
    color: #666666;
  }
  .card-list{
    padding: 0 12px;
  }
  .group-buy-progress {
    padding-left: 12px;
    padding-right: 12px;
    flex: 1;
  }
</style>
